import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackOffersNearbyClick } from './tracking';
import { NearbyNewbuildingsLink } from '../../components/NearbyNewbuildingsLink';
import { selectNearbyNewbuildingsMapUrl } from '../../selectors/newObject';

export function NearbyNewbuildingsLinkContainer() {
  const nearbyNewbuildingsMapUrl = useSelector(selectNearbyNewbuildingsMapUrl);

  if (!nearbyNewbuildingsMapUrl) {
    return null;
  }

  return <NearbyNewbuildingsLink url={nearbyNewbuildingsMapUrl} onClick={trackOffersNearbyClick} />;
}
